import { motion } from "framer-motion";
import { MapPin, Clock, BadgeCheck } from "lucide-react";

export default function About({ content }) {
  return (
    <section id="about" className="relative py-24 sm:py-32 bg-storm-800/20" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-2 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="relative"
        >
          <div className="absolute -inset-6 bg-gold/10 blur-[80px] rounded-full" />
          <div className="relative overflow-hidden rounded-3xl border border-gold/20 [clip-path:polygon(0_0,100%_0,100%_88%,88%_100%,0_100%)]">
            <img src="/work-2.jpg" alt="DRC502 completed roofing project" className="w-full h-[420px] sm:h-[520px] object-cover" data-testid="about-image" />
            <div className="absolute inset-0 bg-gradient-to-t from-storm/80 to-transparent" />
            <div className="absolute bottom-5 left-5 right-5 flex items-center gap-3">
              <BadgeCheck size={20} className="text-gold shrink-0" />
              <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/90">{content.tagline}</span>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-gold mb-4">Who we are</p>
          <h2 className="font-display font-bold italic uppercase text-4xl sm:text-5xl text-white leading-[0.95]" data-testid="about-title">
            {content.about_title}
          </h2>
          <p className="mt-6 text-slate-400 text-base sm:text-lg leading-relaxed" data-testid="about-text">
            {content.about_text}
          </p>
          <div className="mt-8 flex flex-col gap-3">
            <div className="flex items-center gap-3 text-slate-300" data-testid="about-area">
              <MapPin size={17} className="text-gold shrink-0" />
              <span className="text-sm">{content.area_text}</span>
            </div>
            <div className="flex items-center gap-3 text-slate-300" data-testid="about-hours">
              <Clock size={17} className="text-gold shrink-0" />
              <span className="text-sm">{content.hours_text}</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
